'use client';
import React, { useState, useCallback, useMemo } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { TrackedButton } from '@/components/button';
import { getSafeReferrerUrl } from '@/utils';
import shareIcon from '@images/share.webp';

// 상수
const COPY_SUCCESS_DURATION_MS = 2000;

function CheckIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3 4.3L6 11.6L2.7 8.3"
        stroke="#22c55e"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function CopyUrlButton() {
  const t = useTranslations('Common.copyUrl');
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = useCallback(async () => {
    if (isCopied) return;

    const url = getSafeReferrerUrl(undefined, { includeUtm: false });
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), COPY_SUCCESS_DURATION_MS);
    } catch (err: unknown) {
      console.error('Failed to copy URL:', err);
      alert(t('error'));
    }
  }, [isCopied, t]);

  const buttonClassName = useMemo(
    () =>
      `flex items-center rounded-[6px] border px-1.5 py-1 transition-colors ${
        isCopied
          ? 'border-green-500 bg-green-50'
          : 'border-[#a1a7b2] hover:border-3b-text-secondary'
      }`,
    [isCopied],
  );

  return (
    <TrackedButton
      label="copy-url"
      position="main_cta"
      className={buttonClassName}
      aria-label={isCopied ? t('copied') : t('label')}
      onClick={handleClick}
    >
      {isCopied ? (
        <CheckIcon />
      ) : (
        <Image src={shareIcon} alt="copy url" width={16} height={16} priority />
      )}
    </TrackedButton>
  );
}
